import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { IdleTimerService } from './idle-timer.service';
import { Router } from '@angular/router';
import { ApiService } from '../../services/common/api.service';
import { LoginRedirectionService } from './login-redirection.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SsoAuthService {
  private refreshUrl = '/api/external/v1/auth/refreshToken';

  private timerInterval: any;
  public tokenExpiresInSecond: BehaviorSubject<any> = new BehaviorSubject(null);
  public isRefreskTokenApiCalled = false;


  constructor(
    private router: Router,
    private api: ApiService,
    private idleTimerService: IdleTimerService,
    private loginredirect: LoginRedirectionService
  ) { }

  public logOut(isAllLogout: boolean = true) {
    this.clearTimer();
    localStorage.clear();
    this.idleTimerService.stopWatching();

    if (isAllLogout) {
      const redirectUrl = `${environment.SSO_URL}?logout=true`;
      window.location.href = redirectUrl;
    } else {
      // this.loginredirect.loginredirection()
    }

    // this.router.navigate(['/']);
  }

  public initTimer() {
    try {
      this.clearTimer();
      const accessToken = localStorage.getItem('AccessToken');
      if (typeof accessToken !== 'undefined' && accessToken) {
        const accessTokenSplit = accessToken.split('.');
        const accessPayloadPart = accessTokenSplit[1];
        const decodedPayload = JSON.parse(window.atob(accessPayloadPart));
        const tokenExpiryTimestamp = decodedPayload.exp;
        const timeRemainingInSeconds = Math.round(
          new Date(tokenExpiryTimestamp).getTime() - new Date().getTime() / 1000
        );
        this.tokenExpiresInSecond.next(9000);
        this.timerInterval = setInterval(() => {
          this.tokenExpiresInSecond.next(
            this.tokenExpiresInSecond.getValue() - 1
          );
        }, 1000);
      }
    } catch (e) {
      console.error('initTimer ERROR: ', e);
    }
  }

  public clearTimer() {
    clearInterval(this.timerInterval);
  }

  public renewAccessToken() {
    this.isRefreskTokenApiCalled = true;
    this.api.post(`${environment.BASE_URL}` + this.refreshUrl).subscribe({
      next: (response: any) => {

        if (localStorage.getItem('AccessToken')) {
          localStorage.setItem('AccessToken', response?.data?.newAccessToken);
          this.initTimer();
        }
        this.isRefreskTokenApiCalled = false;
      },
      error: (error) => {
        throwError(() => error);
        this.isRefreskTokenApiCalled = false;
      },
    });
  }
}
